import { TEMPLATE } from '../../config';

import React from 'react';

export interface TemplateProps {
    hasPendingRequests: boolean;
}

const TemplateComponent = React.lazy(() => {
    switch (TEMPLATE) {
        case 'new_iek': {
            return import('./new-iek');
        }
        case 'new_itk': {
            return import('./new-itk');
        }
        case 'oni': {
            return import('./oni');
        }
        case 'iek_lighting': {
            return import('./iek-lighting');
        }
        case 'generica': {
            return import('./generica');
        }
    }
    throw new Error('Некорректный шаблон каталога: ' + TEMPLATE);
});

export default TemplateComponent;
